import React, { Component } from 'react';
import { connect } from 'react-redux';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts/highstock';
import AssetConfig from '../../components/assetconfig';
import Loader from '../../components/loader';
import moment from 'moment';

import {
  fetchDailyLedger,
} from '../../actions';

class ValueGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timePeriod: 'ONE_MONTH',
      groupedLedger: [],
      dailyLedgerLoading: true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.graphData = this.graphData.bind(this);
    this.getDateArray = this.getDateArray.bind(this);
    this.updateLedger = this.updateLedger.bind(this);
    this.getTodayValue = this.getTodayValue.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    this.updateLedger();
  }

  handleChange(event) {
    this.setState({ [event.target.id]: event.target.value, pristine: false });
    if (event.target.id === 'timePeriod') {
      this.updateLedger(event.target.value);
    }
  }

  processData(item, gDates) {
    let processedData = [];
    if (item && item.data) {
      processedData = [...item.data];
    }
    let itemHandle;
    if (item && item.handle) {
      itemHandle = item.handle;
    }
    const now = moment().format('YYYYMMDD');
    gDates.forEach((date) => {
      const found = processedData.some(function(el) {
        return Number(el.date) === Number(date);
      });
      if (!found) {
        if (Number(now) === Number(date)) {
          const todayData = this.getTodayValue(itemHandle);
          processedData.push({
            date: Number(now),
            foreignID: 'TODAY',
            handle: itemHandle,
            runningTotal: todayData.runningTotal,
            value: todayData.value,
          });
        } else {
          processedData.push({
            date: Number(date),
            foreignID: 'PADDED',
            handle: itemHandle,
            runningTotal: '0.0000',
            value: '0.0000',
          });
        }
      }
    });
    processedData.sort((a, b) => moment(a.date) - moment(b.date));
    return processedData;
  }

  getTodayValue(handle) {
    const { balance } = this.props;
    const todayData = {
      runningTotal: '0.0000',
      value: '0.0000',
    };
    let handleFx;
    if (balance && balance.fxData && balance.fxData.length) {
      handleFx = balance.fxData.find(function(item) {
        return item.handle === handle;
      });
    }
    let balanceSettled;
    if (balance && balance.data && balance.data.length) {
      balanceSettled = balance.data.filter(function(item) {
        return item.type === 'SETTLED';
      });
    }
    let handleBalance;
    if (balanceSettled && balanceSettled.length) {
      handleBalance = balance.data.find(function(item) {
        return item.handle === handle;
      });
    }
    if (handleFx) {
      todayData.value = handleFx.value;
    }
    if (handleBalance) {
      todayData.runningTotal = handleBalance.total;
    }
    return todayData;
  }

  getTotalValue(item) {
    const { user, dailyPrices, userCurrencyHandle, cachedPrices } = this.props;

    let usePrices = dailyPrices;
    if (cachedPrices && cachedPrices.length) {
      usePrices = cachedPrices;
    }

    let useCurrHandle;
    if (userCurrencyHandle) {
      switch (userCurrencyHandle) {
        case 'CENT':
          useCurrHandle = 'USD';
          break;
        case 'EURCENT':
          useCurrHandle = 'EUR';
          break;
        default:
          useCurrHandle = userCurrencyHandle;
          break;
      }
    }

    let itemDate;
    if (item && item.date) {
      itemDate = item.date;
    }
    let chartDate;
    if (itemDate) {
      chartDate = moment(itemDate.toString()).valueOf();
    }
    let runningTotal;
    if (item && item.runningTotal) {
      runningTotal = item.runningTotal;
    }
    let priceForDate;
    if (itemDate) {
      priceForDate = usePrices.filter((priceD) => Number(priceD[0]) === Number(itemDate));
    }
    let pricePair;
    if (item.handle && userCurrencyHandle) {
      pricePair = item.handle + useCurrHandle;
    }
    let priceForPair;
    if (pricePair && priceForDate) {
      priceForPair = priceForDate.find((priceP) => priceP[1] === pricePair);
      if (!priceForPair) {
        priceForPair = [itemDate, pricePair, '0.0000'];
      }
    }
    let totalValue;
    const now = moment().format('YYYYMMDD');
    if ((priceForPair && priceForPair.length) && runningTotal && item.handle && itemDate) {
      if (Number(now) === Number(itemDate)) {
        totalValue = (Number(runningTotal) / 100);
      } else {
        totalValue = (Number(priceForPair[2]) / 100) * Number(runningTotal);
      }
    }
    return ([chartDate, Number(totalValue)]);
  }

  getDateArray(stopDate, startDate) {
    const dateArray = [];
    let currentDate = moment(startDate);
    while (stopDate <= currentDate) {
      dateArray.push( moment(stopDate).format('YYYYMMDD') );
      stopDate = moment(stopDate).add(1, 'days');
    }
    return dateArray;
  }

  graphData() {
    const { showAsset, AssetOrder } = this.props;
    const { timePeriod, groupedLedger } = this.state;
    const ledger = groupedLedger;
    const dataLoop = {
      series: {},
      startDate: [],
      xInterval: '',
    };

    const now = moment();
    let since;
    switch (timePeriod) {
      case 'SIX_MONTHS':
        dataLoop.xInterval = 30 * 24 * 3600 * 1000;
        since = moment().subtract(180, 'days');
        break;
      case 'ONE_MONTH':
        dataLoop.xInterval = 4 * 24 * 3600 * 1000;
        since = moment().subtract(30, 'days');
        break;
      case 'ONE_WEEK':
        dataLoop.xInterval = 1 * 24 * 3600 * 1000;
        since = moment().subtract(7, 'days');
        break;
      default:
        dataLoop.xInterval = 1 * 24 * 3600 * 1000;
        since = moment().subtract(2, 'days');
        break;
    }
    const gDates = this.getDateArray(since, now);
    if (gDates && gDates.length) {
      dataLoop.startDate = gDates[0];
    }

    let orderedLedger;
    if (ledger) {
      orderedLedger = ledger.slice().sort(function (a, b) {
        let aIndex = AssetOrder.indexOf(a.handle);
        let bIndex = AssetOrder.indexOf(b.handle);
        if (aIndex == -1) {
          aIndex = AssetOrder.length + 1;
        }
        if (bIndex == -1) {
          bIndex = AssetOrder.length + 1;
        }
        const sorted = aIndex - bIndex;
        return sorted;
      });


      dataLoop.series = orderedLedger.map((item) => {
        let processedData = [];
        if (gDates && gDates.length) {
          processedData = this.processData(item, gDates);
        }
        let gData = [];

        const colors = {};
        if (AssetConfig && AssetConfig.length) {
          AssetConfig.forEach((conf) => {
            let useHandle;
            if (conf.handle) {
              useHandle = conf.handle;
            }
            let useColors;
            if (conf.colors) {
              useColors = conf.colors;
            }
            colors[useHandle] = useColors;
          });
        }

        let assetStyle = {
          line: 'rgb(253, 213, 0)',
          gradientStart: 'rgba(253, 213, 0, 0.3)',
          gradientEnd: 'rgba(190, 120, 2, 0)',
        };

        if (item.handle) {
          if (colors && colors[item.handle]) {
            let primary;
            let secondary;
            if (colors[item.handle].primary) {
              primary = colors[item.handle].primary;
            }
            if (colors[item.handle].secondary) {
              secondary = colors[item.handle].primary;
            }
            assetStyle = {
              line: 'rgb(' + primary + ')',
              gradientStart: 'rgba(' + primary + ', 0.3)',
              gradientEnd: 'rgba(' + secondary + ', 0)',
            };
          }
          if (showAsset(item.handle)) {
            gData = processedData.map((a) => (
              this.getTotalValue(a)
            ));
            return {
              name: item.handle,
              data: gData,
              color: assetStyle.line,
              fillColor: {
                linearGradient: {
                  x1: 0,
                  y1: 0,
                  x2: 0,
                  y2: 1,
                },
                stops: [
                  [0, assetStyle.gradientStart],
                  [1, assetStyle.gradientEnd],
                ],
              },
            };
          }
        }
      }).filter(Boolean);
    }
    return dataLoop;
  }

  updateLedger(period) {
    const { dispatch, user, allowedAssets } = this.props;
    const { timePeriod } = this.state;
    this.setState({ dailyLedgerLoading: true });
    let referenceId;
    if (user && user.me && user.me.referenceId) {
      referenceId = user.me.referenceId;
    }
    let usePeriod = timePeriod;
    if (period) {
      usePeriod = period;
    }
    const now = moment();
    let since;
    switch (usePeriod) {
      case 'SIX_MONTHS':
        since = now.subtract(180, 'days');
        break;
      case 'ONE_MONTH':
        since = now.subtract(30, 'days');
        break;
      case 'ONE_WEEK':
        since = now.subtract(7, 'days');
        break;
      default:
        since = now.subtract(2, 'days');
        break;
    }

    const updateGroupLedger = [];
    let data;
    let loopNumber = 0;
    allowedAssets.forEach((item) => {
      data = {
        since: moment(since).unix(),
        handle: item,
      };
      dispatch(fetchDailyLedger(data, referenceId))
        .then((res) => {
          if (res.type === 'FETCH_DAILY_LEDGER_SUCCESS') {
            updateGroupLedger.push(
              {
                handle: item,
                data: res.payload.data,
              },
            );
            loopNumber += 1;
            this.setState({ groupedLedger: updateGroupLedger });
          }
          if (res.type === 'FETCH_DAILY_LEDGER_FAIL') {
            loopNumber += 1;
          }
          if (loopNumber === (allowedAssets.length - 1)) {
            this.setState({ dailyLedgerLoading: false });
          }
        });
    });
  }

  render() {
    const { balance, user, currencySign, toLocaleFixed, userCurrencyHandle, dailyLedger, dailyPrices, dailyPricesLoading, cachedPrices } = this.props;
    const { timePeriod, dailyLedgerLoading, groupedLedger } = this.state;
    const ledgerLoading = Object.keys(groupedLedger).length === 0 && groupedLedger.constructor === Object;

    let themePref = 'DARK';
    if (localStorage.getItem('_vt_theme')) {
      themePref = localStorage.getItem('_vt_theme');
    }
    let textColour = '#ffffff';
    if (themePref === 'LIGHT') {
      textColour = '#2e2e45';
    }

    if (!ledgerLoading) {
      let currSign;
      if (userCurrencyHandle) {
        currSign = currencySign(userCurrencyHandle);
      }

      const graphData = this.graphData();

      let usePrices = dailyPrices;
      if (cachedPrices && cachedPrices.length) {
        usePrices = cachedPrices;
      }

      const chartReady = (groupedLedger && Object.keys(groupedLedger).length) && (usePrices && usePrices.length);

      const chartOptions = {
        chart: {
          type: 'area',
          marginBottom: 100,
          backgroundColor: 'rgba(0, 2, 4, 0)',
        },
        title: '',
        credits: false,
        xAxis: {
          offset: 0,
          lineColor: '#374964',
          tickWidth: 0,
          tickLength: 5,
          tickColor: '#374964',
          tickInterval: graphData.xInterval,
          labels: {
            style: {
              fontFamily: 'DroidSansMono',
              color: textColour,
              fontSize: '12px',
            },
          },
          type: 'datetime',
          title: {
            text: 'Date',
            style: {
              fontFamily: 'ProximaNova',
              color: textColour,
              fontSize: '14px',
            },
          },
        },
        yAxis: [
          {
            lineWidth: 0,
            gridLineWidth: 0,
            title: {
              text: 'Value in ' + currSign,
              style: {
                fontFamily: 'ProximaNova',
                color: textColour,
                fontSize: '14px',
              },
            },
            tickWidth: 0,
            tickLength: 5,
            tickPosition: 'inside',
            tickColor: '#374964',
            labels: {
              align: 'right',
              x: -8,
              style: {
                fontFamily: 'DroidSansMono',
                color: textColour,
                fontSize: '12px',
              },
            },
          },
        ],
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
          symbolHeight: 8,
          symbolWidth: 8,
          symbolRadius: 8,
          symbolPadding: 10,
          itemMarginTop: 10,
          itemMarginBottom: 10,
          itemStyle: {
            fontFamily: 'DroidSansMono',
            color: textColour,
            fontSize: '12px',
            fontWeight: 'normal',
          },
          itemHoverStyle: {
            fontFamily: 'DroidSansMono',
            color: textColour,
            fontSize: '12px',
            fontWeight: 'normal',
          },
        },
        plotOptions: {
          series: {
            pointPlacement: 'on',
            pointStart: moment(graphData.startDate).valueOf(),
            pointInterval: 1 * 24 * 3600 * 1000, // 1 day
          },
          area: {
            stacking: 'normal',
            lineWidth: 2,
            marker: false,
          },
        },
        tooltip: {
          formatter: function () {
            return (this.series.name + ' Value: <span class="label-num">' + currSign + toLocaleFixed(this.y, 2) + '</span> <br> Total Value: <span class="label-num">' + currSign + toLocaleFixed(this.point.total, 2) + '</span> <br>Date: <span class="label-num">' + moment(this.x).format('L') + '</span> <br>');
          },
          shared: false,
        },
        series: graphData.series,
      };

      return (
        <div className="vc-con">
          <div className="panel-label">
            <div></div>
            <div>
              Total Portfolio Value Over Time
            </div>
            <div>
              <select style={{ width: 120 }} id="timePeriod" value={timePeriod} onChange={this.handleChange}>
                <option value="SIX_MONTHS">6 MONTHS</option>
                <option value="ONE_MONTH">1 MONTH</option>
                <option value="ONE_WEEK">1 WEEK</option>
              </select>
            </div>
          </div>
          {dailyLedgerLoading || dailyPricesLoading ? (
            <div className="center-loader">
              <Loader logo />
            </div>
          ) : (
            <div>
              {chartReady ? (
                <HighchartsReact
                  // constructorType={'chart'}
                  highcharts={Highcharts}
                  options={chartOptions}
                />
              ) : (
                <div>
                  <h3 style={{ textAlign: 'center' }}>No Data</h3>
                </div>
              )}
            </div>
          )}
        </div>
      );
    }

    return (
      <div className="vc-con">
        <div className="center-loader">
          <Loader logo />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  balance: state.balance.balance,
  errors: state.user.errors,
  dailyPrices: state.balance.daily,
  dailyLedger: state.ledger.daily,
});

export default connect(mapStateToProps)(ValueGraph);
